<script setup lang="ts">
/**
 * ITO Consult logo — inline SVG ("ITO" + red circle), same asset as in
 * HeroSection. The letters use `currentColor` so the surrounding element
 * controls the tint (white over video, dark on white footer); the red
 * circle keeps its brand color #E30613.
 *
 * Root is a link to https://ito-consult.de/ (new tab). Size is controlled
 * by the parent (width classes on the svg or wrapper).
 */
const clipId = `ito-logo-clip-${useId()}`
</script>

<template>
  <a
    href="https://ito-consult.de/"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="ITO Consult"
    class="inline-flex"
  >
    <svg
      width="523"
      height="292"
      viewBox="0 0 523 292"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="h-auto w-full"
    >
      <g :clip-path="`url(#${clipId})`">
        <path d="M37.2002 135.6V291.4H88.0002V135.6C88.0002 135.6 62.6002 147.3 37.2002 135.6Z" fill="currentColor" />
        <path d="M437.9 37.3H135.2C135.2 37.3 145.9 62.2 135.4 88L152.8 88.1V291.4H203.6V88H272.85C269.957 97.8933 268.507 109.227 268.5 122V206.7C268.5 263.173 296.734 291.407 353.2 291.4V291.6L437.9 291.4C494.374 291.233 522.607 263 522.6 206.7V122C522.633 65.5333 494.4 37.3 437.9 37.3ZM471.8 198.2C471.8 226.5 457.6 240.6 429.4 240.6H361.7C333.4 240.6 319.3 226.4 319.3 198.2V130.4C319.3 102.133 330.6 88 353.2 88H429.4C457.7 88 471.8 102.2 471.8 130.4V198.2Z" fill="currentColor" />
        <path d="M62.3 124.6C96.7073 124.6 124.6 96.7073 124.6 62.3C124.6 27.8927 96.7073 0 62.3 0C27.8927 0 0 27.8927 0 62.3C0 96.7073 27.8927 124.6 62.3 124.6Z" fill="#E30613" />
      </g>
      <defs>
        <clipPath :id="clipId">
          <rect width="522.6" height="291.6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </a>
</template>
